import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Divider, TextField, MenuItem, SelectField, RaisedButton, DatePicker,
  Card, CardText, Drawer, Dialog, FlatButton, CircularProgress, Chip, List, ListItem, ListItemSecondaryAction, Avatar
} from "material-ui";
import DeleteIcon from "material-ui/svg-icons/action/delete";
import DateIcon from "material-ui/svg-icons/action/date-range";
import Add from "material-ui/svg-icons/content/add-circle";
import Getapp from "material-ui/svg-icons/action/get-app";
import {
  BuscarPaqueteGES, BuscarTotalPaginas, obtenerCanastas, Loading, LoadingExcel, obtenerTiposAtencion, obtenerProblemasSalud, CambiarIntSanitaria, CambiarCodIsapre, CambiarCodPrestador, OpenCargarBorrador, LimpiarCanastas, obtenerIntSanitarias, CambiarTipoAtencion, CambiarCanasta,
  SetSolicitudesEnCurso, CambiarProblemaSalud, GetSolicitudesExcel, CambiarInicioVigencia, CambiarCodIntervencion, CambiarCodPaquetePres, CambiarGlosa
} from "./actions";
import {
  ObtenerCentrosAtencion, ObtenerTiposArancel,
  CambiarTipoArancel, CambiarCentroAtencion, ObtenerUsuariosPerfil, ObtenerDatosUsuario,
} from "../../Global/actions";
import GrillaBusquedaAG from "../GrillaBusquedaPaqueteGES/view";
//import GrillaSolicitud from "../GrillaSolicitud/view";
//import NuevaPrestacionForm from "../NuevaPrestacionForm/view";
import ErrorSnack from "../../ErrorSnack/view";
//import { AddPrestacionSolicitud, UpdateIdSolicitud } from "../GrillaSolicitud/actions";
import guid from "../../../helpers/guid";
import styles from "../../styles/styles";
import apiConfig from "../../../config/api";
//import { ObtenerTiposArancelAll } from "../NuevaPrestacionForm/actions";
import banmedicaTheme from "../../../config/banmedicaTheme";
import customDateTimeFormat from "../../../helpers/dateFormat";
// import DialogAlert from "../../../componentsGlobal/DialogAlert";

class FiltroBusquedaPG extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cambiosSinGuardar: false,
      infoAlert: false,
      disabledCanasta: true,
      todos: true,
    };
  }
  componentWillMount() {
    window.removeEventListener("beforeunload", this.onUnload.bind(this));
    //this.props.dispatch(ObtenerUsuariosPerfil(`${apiConfig.usuariosContraloria}`, 1));
    //this.props.dispatch(ObtenerUsuariosPerfil(`${apiConfig.usuariosConvenios}`, 2));
    this.props.dispatch(ObtenerCentrosAtencion());
    this.props.dispatch(obtenerTiposAtencion());
    this.props.dispatch(obtenerProblemasSalud());
    this.props.dispatch(obtenerIntSanitarias());
    //this.props.dispatch(obtenerTiposPrestacion());
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onUnload.bind(this));
  }


  onUnload(event) { // the method that will be used for both add and remove event
    if (this.state.cambiosSinGuardar) {
      event.returnValue = true;
    }
  }

  CambiosSinGuardar = (cambios) => {
    this.setState({ cambiosSinGuardar: cambios });
  }

  ExportarExcel = () => {
    this.props.dispatch(LoadingExcel(true));
    this.props.dispatch(GetSolicitudesExcel());
  }

  CambiarTipoArancel = (event, index, value) => {
    this.props.dispatch(CambiarTipoArancel(value));
  }

  CambiarIntSanitaria = (event, index, value) => {
    this.props.dispatch(CambiarIntSanitaria(value));
    if (value != 'A') {
      if (this.props.filtros.problemaSalud != 0) {
        //this.props.dispatch(CambiarCanasta(0));
        this.props.dispatch(obtenerCanastas());
        this.setState({ disabledCanasta: false });
      }
    } else {
      this.props.dispatch(CambiarCanasta(null));
      this.props.dispatch(LimpiarCanastas());
      this.setState({ disabledCanasta: true });
    }
  }

  CambiarProblemaSalud = (event, index, value) => {
    this.props.dispatch(CambiarProblemaSalud(value));
    if (value != 0) {
      if (this.props.filtros.intervencionSanitaria != 'A') {
        //this.props.dispatch(CambiarCanasta(0));
        this.props.dispatch(obtenerCanastas());
        this.setState({ disabledCanasta: false });
      }
    } else {
      this.props.dispatch(CambiarCanasta(null));
      this.props.dispatch(LimpiarCanastas());
      this.setState({ disabledCanasta: true });
    }
  }

  CambiarCentroAtencion = (event, index, value) => {
    this.props.dispatch(CambiarCentroAtencion(value));
    this.setState({ todos: false });
    //this.props.dispatch(ObtenerTiposPrestacion(value));
    //this.props.dispatch(ObtenerTiposArancel(value));
  }

  CambiarCanasta = (event, index, value) => {
    this.props.dispatch(CambiarCanasta(value));
  }

  CambiarCodFonasa = (event) => {
    const re = /^[0-9;]+$/;
    if (event.target.value === "" || re.test(event.target.value)) {
      this.props.dispatch(CambiarCodIsapre(event.target.value));
    }
  }

  CambiarCodPrestacion = (event) => {
    this.props.dispatch(CambiarCodPrestador(event.target.value));
  }

  CambiarTipoAtencion = (event, index, value) => {
    this.props.dispatch(CambiarTipoAtencion(value));
  }

  BuscarPaqueteGES = (event, index, value) => {
    this.props.dispatch(Loading(true));
    this.props.dispatch(BuscarPaqueteGES(value));
    this.props.dispatch(BuscarTotalPaginas(value));
  }

  /*NuevaPrestacion = () => {
    this.props.dispatch(NuevaPrestacion());
  }*/

  CloseSetSolicitudesEnCurso = () => {
    this.props.dispatch(SetSolicitudesEnCurso(false));
  }

  CambiarInicioVigencia = (event, date) => {
    this.props.dispatch(CambiarInicioVigencia(date));
  }

  /*CargarDetalleSolicitud = () => {
    // this.props.dispatch(GetDetalleSolicitud(this.props.idSolicitud));

    this.props.prestacionesSolicitud.forEach((element) => {
      // Por haber incongruencia en los datos, cuando se carga de base de datos, se setea local
      // La fecha viene en formato zulu porque en base de datos se guarda solo la fecha, sin la hora, cuando regresa, el locate lo pasa a menos 3 horas, visualmente se resta u dia
      // por eso se realiza la tranformacion local, para que pase a gmt
      let FechaInicioVigenciaPosterior = null;
      if (element.FechaInicioVigenciaPosterior) {
        const anho = Number(element.FechaInicioVigenciaPosterior.substring(0, 4));
        const mes = Number(element.FechaInicioVigenciaPosterior.substring(5, 7)) - 1;
        const dia = Number(element.FechaInicioVigenciaPosterior.substring(8, 10));
        FechaInicioVigenciaPosterior = new Date(anho, mes, dia);
      }
      let FechaTerminoVigenciaPosterior = null;
      if (element.FechaTerminoVigenciaPosterior) {
        const anho = Number(element.FechaTerminoVigenciaPosterior.substring(0, 4));
        const mes = Number(element.FechaTerminoVigenciaPosterior.substring(5, 7)) - 1;
        const dia = Number(element.FechaTerminoVigenciaPosterior.substring(8, 10));
        FechaTerminoVigenciaPosterior = new Date(anho, mes, dia);
      }
      // el codigo de operacion, viene en numero, pero en la web se usa como strig, con validacione varias
      const IdTipoAccionPrestacion = element.IdTipoAccionPrestacion ? element.IdTipoAccionPrestacion.toString() : "";

      //console.log("PRESTACION:", element);

      const prest = {
        COD_PRESTADOR: element.CodigoPrestacionPrestador,
        GLOSA_CODPRESTADOR: element.GlosaPrestacionPrestador,
        COD_ISAPRE: element.CodigoPrestacionIsapre,
        PROF_CCOD: element.CodigoProfesionalIsapre,
        VALOR: element.ValorPosterior,
        UNIDAD: element.UnidadPosterior,
        TIPO_ATENCION: element.TipoAtencion,
        // INICIO_VIG: element.IdTipoAccionPrestacion === 2 ? FechaTerminoVigenciaPosterior : FechaInicioVigenciaPosterior,
        INICIO_VIG: FechaInicioVigenciaPosterior,
        FECHA_FIN_VIG: FechaTerminoVigenciaPosterior,
        TIPO_PRESTACION: "",
        GUARISMO: element.GuarismoDP,
        PERTENENCIA_FONASA: element.PertenenciaFonasa,
        CODIGO_FONASA: element.CodigoFonasa,
        ITEM_IMED: element.ItemImedNumber,
        CENTRO_AT: element.CentroAtencion,
        SECUENCIA: element.CentroAtencionSecuencia,
        ARANCEL: element.GlosaArancel,
        RUTARANCEL: element.Arancel,
        IDPRESTACION: element.IdPrestacionIsapre,
        IDDETALLEPRESTACION: element.IdDetallePrestacionSolicitud,
        OPERACION: element.TipoAccionPrestacion,
        COD_OPERACION: IdTipoAccionPrestacion,
        GUID: guid.new(),
      };
      this.props.dispatch(AddPrestacionSolicitud(prest));
    });

    this.props.dispatch(UpdateIdSolicitud(this.props.idSolicitud, true));
    this.ocultarModalBorrador();
  }*/

  /*eliminarBorrador = () => {
    this.props.dispatch(deleteBorrador(this.props.idSolicitud, this.props.rutPrestador, this.props.rutInstitucion, this.props.isapre));
    this.ocultarModalBorrador();
  }*/

  mostrarModalBorrador = () => {
    this.props.dispatch(OpenCargarBorrador(true));
  }

  ocultarModalBorrador = () => {
    this.props.dispatch(OpenCargarBorrador(false));
  }


  render() {
    const { REACT_APP_REAJUSTAR_ARANCEL_FECHA_VIGENCIA_MINIMA: fechaVigenciaPrestador } = this.props.ENV;
    let today = new Date();
    today.setDate(today.getDate() + fechaVigenciaPrestador);
    const minDate = today;

    const menuListCentroAtencion = [];
    if (this.props.centrosAtencion) {
      menuListCentroAtencion.push(<MenuItem key={999} value={999} primaryText={'TODOS'} style={styles.customWidthItem} />);
      this.props.centrosAtencion.forEach((element) => {
        menuListCentroAtencion.push(<MenuItem key={element.Secuencia} value={element.Secuencia} primaryText={element.Descripcion} style={styles.customWidthItem} />);
      });
    }

    const menuListProblemaSalud = [];
    if (this.props.problemasSalud) {
      for (let i = 0; i < this.props.problemasSalud.length; i++) {
        menuListProblemaSalud.push(<MenuItem key={i} value={this.props.problemasSalud[i].Codigo} primaryText={this.props.problemasSalud[i].Descripcion} style={styles.customWidthItem} />);
      }
    }

    const menuListCanastas = [];
    if (this.props.canastas.length > 0) {
      for (let i = 0; i < this.props.canastas.length; i++) {
        menuListCanastas.push(<MenuItem key={i} value={this.props.canastas[i].Codigo} primaryText={this.props.canastas[i].Descripcion} style={styles.customWidthItem} />);
      }
    }

    const menuListTipoAtencion = [];
    if (this.props.tiposAtencion) {
      for (let i = 0; i < this.props.tiposAtencion.length; i++) {
        menuListTipoAtencion.push(<MenuItem key={i} value={this.props.tiposAtencion[i].Codigo} primaryText={this.props.tiposAtencion[i].Descripcion} style={styles.customWidthItem} />);
      }
    }

    const menuListIntSanitaria = [];
    if (this.props.intSanitarias) {
      for (let i = 0; i < this.props.intSanitarias.length; i++) {
        menuListIntSanitaria.push(<MenuItem key={i} value={this.props.intSanitarias[i].Codigo} primaryText={this.props.intSanitarias[i].Descripcion} style={styles.customWidthItem} />);
      }
    }

    const actionsModalCargarBorrador = [
      <FlatButton
        label="Eliminar"
        secondary
        onClick={this.eliminarBorrador}
      />,
      <FlatButton
        label="Continuar"
        secondary
        onClick={this.CargarDetalleSolicitud}
      />,
    ];

    return (
      <div>
        {this.props.token ?

          <div >
            <div style={styles.frameContenidoGeneral}>
              <Card zDepth={0} style={{ paddingBottom: 0 }}>
                <CardText style={{ paddingBottom: 0 }}>
                  <div className="row" style={{ paddingBottom: 0 }}>
                    <div className="contenido" style={{ margin: 0, padding: 0, width: 925 }}>
                      <div style={styles.h1}>Listado de Paquetes GES
                      </div>
                      <div className="row" style={{ paddingBottom: 25 }}></div>
                      <div className="row"> </div>
                      <div style={styles.h3}>Rut Institución: {this.props.rutInstitucion}
                      </div>
                    </div>
                  </div>
                  {
                    this.props.centrosAtencion && this.props.centrosAtencion.length > 0 &&
                      this.props.problemasSalud && this.props.problemasSalud.length > 0 &&
                      this.props.intSanitarias && this.props.intSanitarias.length > 0 &&
                      this.props.tiposAtencion && this.props.tiposAtencion.length > 0 ?
                      <div>
                        <div className="row">
                          <div className="col-4" style={styles.colSelectFieldActualizar}>
                            <div style={styles.floatingClaseSelect}> Centro de Atención </div>
                            {
                              this.props.centrosAtencion && this.props.centrosAtencion.length > 0 ?
                                <SelectField
                                  name="ag_centroAtencion"
                                  id="ag_centroAtencion"
                                  value={this.state.todos ? this.CambiarCentroAtencion(null, null, 999) : this.props.filtros.centroAtencion}
                                  onChange={this.CambiarCentroAtencion}
                                  labelStyle={styles.h4}
                                  underlineStyle={styles.underlineSelectField}
                                  style={styles.selectFiledStyle}
                                  iconStyle={styles.iconSelectField}
                                  menuItemStyle={styles.menuItemStyleSelectField}
                                  selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                                >
                                  {menuListCentroAtencion}
                                </SelectField>
                                :
                                <CircularProgress />
                            }
                          </div>
                          <div className="col-4" style={styles.colSelectFieldActualizar}>
                            <div style={styles.floatingClaseSelect}> Problema de Salud </div>
                            {
                              this.props.problemasSalud && this.props.problemasSalud.length > 0 ?
                                <SelectField
                                  name="ag_problemaSalud"
                                  id="ag_problemaSalud"
                                  value={this.props.filtros.problemaSalud}
                                  onChange={this.CambiarProblemaSalud}
                                  labelStyle={styles.h4}
                                  underlineStyle={styles.underlineSelectField}
                                  style={styles.selectFiledStyle}
                                  iconStyle={styles.iconSelectField}
                                  menuItemStyle={styles.menuItemStyleSelectField}
                                  selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                                >
                                  {menuListProblemaSalud}
                                </SelectField>
                                :
                                <CircularProgress />
                            }
                          </div>
                          <div className="col-4" style={styles.colSelectFieldActualizar}>
                            <div style={styles.floatingClaseSelect}> Intervención Sanitaria </div>
                            {
                              this.props.intSanitarias && this.props.intSanitarias.length > 0 ?
                                <SelectField
                                  name="ag_intSanitaria"
                                  id="ag_intSanitaria"
                                  value={this.props.filtros.intervencionSanitaria}
                                  onChange={this.CambiarIntSanitaria}
                                  labelStyle={styles.h4}
                                  underlineStyle={styles.underlineSelectField}
                                  style={styles.selectFiledStyle}
                                  iconStyle={styles.iconSelectField}
                                  menuItemStyle={styles.menuItemStyleSelectField}
                                  selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                                >
                                  {menuListIntSanitaria}
                                </SelectField>
                                :
                                <CircularProgress />
                            }
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-4" style={styles.colSelectFieldActualizar}>
                            <div style={styles.floatingClaseSelect2}> Canasta </div>
                            {
                              this.props.problemasSalud && this.props.problemasSalud.length > 0 ?
                                <SelectField
                                  name="pg_canasta"
                                  id="pg_canasta"
                                  disabled={this.state.disabledCanasta === true}
                                  value={this.props.filtros.canasta}
                                  onChange={this.CambiarCanasta}
                                  labelStyle={styles.h4}
                                  underlineStyle={styles.underlineSelectField}
                                  style={styles.selectFiledStyle}
                                  iconStyle={styles.iconSelectField}
                                  menuItemStyle={styles.menuItemStyleSelectField}
                                  selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                                >
                                  {menuListCanastas}
                                </SelectField>
                                :
                                <CircularProgress />
                            }
                          </div>
                          <div className="col-4" style={styles.colSelectFieldActualizar}>
                            <div style={styles.floatingClaseSelect2}> Tipo de Atención </div>
                            {
                              this.props.tiposAtencion && this.props.tiposAtencion.length > 0 ?
                                <SelectField
                                  name="ag_tiposAtencion"
                                  id="ag_tiposAtencion"
                                  value={this.props.filtros.tipoAtencion}
                                  onChange={this.CambiarTipoAtencion}
                                  labelStyle={styles.h4}
                                  underlineStyle={styles.underlineSelectField}
                                  style={styles.selectFiledStyle}
                                  iconStyle={styles.iconSelectField}
                                  menuItemStyle={styles.menuItemStyleSelectField}
                                  selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                                >
                                  {menuListTipoAtencion}
                                </SelectField>
                                :
                                <CircularProgress />
                            }
                          </div>
                          <div className="col-4" style={styles.colSelectFieldActualizar}>
                            <div style={styles.floatingClaseSelect2}> Código del Prestador </div>
                            <TextField
                              name="ag_codPrestador"
                              id="ag_codPrestador"
                              value={this.props.filtros.codPrestador || ""}
                              onChange={this.CambiarCodPrestacion}
                              errorText=""
                              maxLength={15}
                              underlineStyle={styles.underlineSelectField}
                              inputStyle={styles.h4}
                              style={styles.selectFiledStyle}
                            />
                          </div>
                        </div>
                      </div>
                      :
                      <CircularProgress
                        style={{
                          display: "block",
                          marginLeft: "auto",
                          marginRight: "auto",
                          padding: "50px 50px 100px 50px",
                        }}
                      />
                  }
                  <div className="row" style={{ paddingRight: 25 }}>
                    <div className="col-12" style={styles.colBotonesActualizar}>
                      {
                        !this.props.loadingExcel ?
                          <RaisedButton
                            onClick={this.ExportarExcel}
                            label="Exportar a Excel"
                            backgroundColor="#fff"
                            labelPosition="before"
                            overlayStyle={{ borderRadius: 5 }}
                            labelStyle={{
                              fontSize: "11px", color: "#00A100", paddingLeft: 10, paddingRight: 5, top: "-3px",
                            }}
                            style={{ width: "190px", borderRadius: 5 }}
                            buttonStyle={{ border: "2px solid #C3C3C3", borderRadius: 5 }}
                            icon={<Getapp />}
                            disabled={
                              !(this.props.centrosAtencion && this.props.centrosAtencion.length > 0 &&
                                this.props.problemasSalud && this.props.problemasSalud.length > 0 &&
                                this.props.intSanitarias && this.props.intSanitarias.length > 0 &&
                                this.props.tiposAtencion && this.props.tiposAtencion.length > 0)
                            }
                          />
                          :
                          <CircularProgress />
                      }
                      {!this.props.loading ?
                        <RaisedButton
                          label="Buscar"
                          onClick={this.BuscarPaqueteGES}
                          secondary
                          labelStyle={{ fontSize: "11px" }}
                          overlayStyle={{ borderRadius: 5 }}
                          rippleStyle={{ borderRadius: 5 }}
                          style={{ width: "130px", borderRadius: 5, marginLeft: 20 }}
                          buttonStyle={{ borderRadius: 5 }}
                          disabled={
                            !(this.props.centrosAtencion && this.props.centrosAtencion.length > 0 &&
                              this.props.problemasSalud && this.props.problemasSalud.length > 0 &&
                              this.props.intSanitarias && this.props.intSanitarias.length > 0 &&
                              this.props.tiposAtencion && this.props.tiposAtencion.length > 0)
                          }
                        />
                        :
                        <RaisedButton
                          label="Cargando ..."
                          secondary
                          labelStyle={{ fontSize: "11px" }}
                          overlayStyle={{ borderRadius: 5 }}
                          rippleStyle={{ borderRadius: 5 }}
                          style={{ width: "130px", borderRadius: 5, marginLeft: 20 }}
                          buttonStyle={{ borderRadius: 5 }}
                        />
                      }
                    </div>

                    <div className="contenido" style={{ margin: 0, padding: 0, width: 925 }}>
                      <div style={styles.h3}>Email de contacto</div>
                      <div style={styles.h2}>
                        Las notificaciones se realizarán a la siguiente dirección de correo electrónico:&nbsp;<strong>{this.props.datosUsuario.mail}</strong><br />
                        Si desea modificar el email de contacto, debe cambiarlo en la sección &quot;Datos del Prestador&quot;
                      </div>
                    </div>

                  </div>
                </CardText>
              </Card>
            </div>
            <div className="row" style={{ padding: 10, margin: "15px 0px 0px 0px" }} >
              <div className="col-12">
                <Divider />
              </div>
            </div>

            <GrillaBusquedaAG CambiosSinGuardar={this.CambiosSinGuardar} />

            <div className="row" style={{ padding: 10, margin: "15px 0px 0px 0px" }}>
              <div className="col-12">
                <Divider />
              </div>
            </div>

            {/*<GrillaSolicitud CambiosSinGuardar={this.CambiosSinGuardar} />

            <Drawer
              width="100%"
              openSecondary
              open={this.props.modalNuevaPrestacion}
              docked={false}

            >
              {(this.props.modalNuevaPrestacion) ?
                <NuevaPrestacionForm CambiosSinGuardar={this.CambiosSinGuardar} />
                : null}
            </Drawer>*/}

            <Dialog
              key="modalCargarBorrador"
              actions={actionsModalCargarBorrador}
              modal
              open={this.props.modalCargarBorrador}
              style={{ width: "100%", fontSize: "13px" }}
            >
              Usted tiene una solicitud incompleta ¿desea continuar la lista o eliminarla?
            </Dialog>

            <ErrorSnack />

            {this.props.solicitudEnCurso ?
              <Dialog
                key="modalSolicitudencurso"
                actions={[
                  <FlatButton
                    label="Aceptar"
                    secondary
                    onClick={this.CloseSetSolicitudesEnCurso}
                  />]}
                modal
                open={this.props.solicitudEnCurso}
                style={{ width: "100%", fontSize: "13px" }}
              >
                <p>Usted tiene una solicitud en curso con prestaciones aún pendientes.</p>
                <p>Debe esperar a que la solicitud esté resuelta, para enviar una nueva solicitud.</p>
              </Dialog> : null}
          </div>

          :
          null}
      </div>
    );
  }
}

FiltroBusquedaPG.defaultProps = {
  idSolicitud: null,
  loading: null,
  loadingExcel: null,
};

FiltroBusquedaPG.propTypes = {
  loadingExcel: PropTypes.bool,
  loading: PropTypes.bool,
  rutInstitucion: PropTypes.number.isRequired,
  rutPrestador: PropTypes.number.isRequired,
  isapre: PropTypes.string.isRequired,
  tiposArancel: PropTypes.array.isRequired,
  centrosAtencion: PropTypes.array.isRequired,
  tiposPrestaciones: PropTypes.array.isRequired,
  tiposAtencion: PropTypes.array.isRequired,
  problemasSalud: PropTypes.array.isRequired,
  tiposPrestacion: PropTypes.array.isRequired,
  //problemasSalud: PropTypes.array.isRequired,
  canastas: PropTypes.array.isRequired,
  modalNuevaPrestacion: PropTypes.bool.isRequired,
  modalCargarBorrador: PropTypes.bool.isRequired,
  //inicioVigenciaPaquete: PropTypes.any.isRequired,
  prestacionesSolicitud: PropTypes.array.isRequired,
  idSolicitud: PropTypes.number,
  solicitudEnCurso: PropTypes.bool.isRequired,
  filtros: PropTypes.any.isRequired,
  datosUsuario: PropTypes.any.isRequired,
  dispatch: PropTypes.func.isRequired,
  ENV: PropTypes.any.isRequired,
  token: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  pageSize: state.filtroBusqueda.pageSize,
  totalPaginas: state.filtroBusqueda.totalPaginas,
  loadingExcel: state.filtroBusqueda.loadingExcel,
  loading: state.filtroBusqueda.loading,
  rutPrestador: state.global.rutPrestador,
  isapre: state.global.isapre,
  rutInstitucion: state.global.rutInstitucion,
  tiposArancel: state.global.filtros_CAT.tiposArancel,
  centrosAtencion: state.global.filtros_CAT.centrosAtencion,
  tiposPrestaciones: state.global.filtros_CAT.tiposPrestaciones,
  tiposAtencion: state.filtroBusquedaPG.tiposAtencion,
  problemasSalud: state.filtroBusquedaPG.problemasSalud,
  intSanitarias: state.filtroBusquedaPG.intSanitarias,
  canastas: state.filtroBusquedaPG.canastas,
  modalNuevaPrestacion: state.filtroBusquedaPQ.modalNuevaPrestacion,
  modalCargarBorrador: state.filtroBusquedaPQ.modalCargarBorrador,
  prestacionesSolicitud: state.filtroBusqueda.prestacionesSolicitud,
  idSolicitud: state.filtroBusquedaPQ.idSolicitud,
  solicitudEnCurso: state.filtroBusquedaPQ.solicitudEnCurso,
  token: state.global.token,
  filtros: {
    centroAtencion: state.global.filtros_CAT.centroAtencion,
    tipoAtencion: state.filtroBusquedaPG.filtros.tipoAtencion,
    problemaSalud: state.filtroBusquedaPG.filtros.problemaSalud,
    intervencionSanitaria: state.filtroBusquedaPG.filtros.intervencionSanitaria,
    canasta: state.filtroBusquedaPG.filtros.canasta,
    codIsapre: state.filtroBusquedaPG.filtros.codIsapre,
    codPrestador: state.filtroBusquedaPG.filtros.codPrestador,
  },
  datosUsuario: state.global.datosUsuario,
  ENV: state.global.ENV,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});


export default connect(mapStateToProps, mapDispatchToProps)(FiltroBusquedaPG);


// export default FiltroBusqueda;